module.exports = __webpack_public_path__ + "static/media/delete-message.a4b91b6f.svg";